import React from 'react';
import { useTranslation } from 'react-i18next';

import MyButton from '@common/components/Button/MyButton';
import SelectWithOptions from '@common/components/SelectWithOptions/SelectWithOptions';
import SettingsRow from '@common/components/SettingsWrapper/SettingsRow';
import SettingsWrapper from '@common/components/SettingsWrapper/SettingsWrapper';
import { RECIPIENT_OPTION } from '@common/constants';
import { copyObjectWithoutRef, isValidEmail } from '@common/helpers/helpers';

import { Box, TextField } from '@mui/material';

export default function Recipients({
  recipients = [],
  setRecipients = () => {},
}) {
  const { t } = useTranslation();
  const recipientTypeOptions = [
    {
      key: 'to',
      value: 'to',
      label: t('type_to'),
    },
    {
      key: 'cc',
      value: 'cc',
      label: t('type_cc'),
    },

    {
      key: 'bcc',
      value: 'bcc',
      label: t('type_bcc'),
    },
  ];
  const onChange = (e, index) => {
    const { name, value } = e.target;

    let newValue = value;
    if (name === 'type') {
      newValue = recipientTypeOptions.find(({ key }) => key === value);
    }

    const updatedItems = copyObjectWithoutRef(recipients);
    updatedItems[index] = {
      ...updatedItems[index],
      [name]: newValue,
    };

    if (
      updatedItems[index]?.invalidEmail &&
      name === 'email' &&
      isValidEmail(value)
    ) {
      delete updatedItems[index].invalidEmail;
    }

    setRecipients(updatedItems);
  };

  const onAddRecipient = () => {
    setRecipients((prevState) => [
      { ...RECIPIENT_OPTION, id: new Date().toISOString() },
      ...prevState,
    ]);
  };

  const onRemoveRecipient = (indexToRemove) => {
    const newArr = recipients.filter((_, index) => index !== indexToRemove);
    setRecipients(newArr);
  };

  return (
    <SettingsWrapper>
      {recipients.map((recipient, index) => (
        <Box key={recipient?.id || index} sx={{ display: 'block', mb: 2 }}>
          <SettingsRow sx={{ mb: 1 }}>
            <SelectWithOptions
              label={t('recipient_type')}
              options={recipientTypeOptions}
              value={recipient?.type?.value || ''}
              name='type'
              onChange={(e) => onChange(e, index)}
            />
            <TextField
              size='small'
              name='email'
              onChange={(e) => onChange(e, index)}
              placeholder={recipient?.type?.label}
              value={recipient.email}
              disabled={!recipient?.type?.key}
              error={recipient?.invalidEmail}
              helperText={recipient?.invalidEmail?.message}
            />
          </SettingsRow>
          <MyButton
            sx={{ width: '200px' }}
            onClick={() => onRemoveRecipient(index)}
          >
            {t('remove_recipient')}
          </MyButton>
        </Box>
      ))}

      <MyButton
        sx={{ maxWidth: '200px', mt: recipients?.length ? 3 : 0 }}
        onClick={onAddRecipient}
      >
        {t('add_recipient')}
      </MyButton>
    </SettingsWrapper>
  );
}
